import React from "react";
import styled from "@emotion/styled";
import { Box } from '@mui/material';
import AccountUserBlock from "./AccountUserBlock";

// Styled Components
const Container = styled(Box)(({ theme }) => ({
    width: '100%',
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(2),
}));

const AccountTabPeople = ({ accountId, accountData }) => {

    return (
        <Container>
            <AccountUserBlock accountId={accountId} accountData={accountData} />
        </Container>
    );
};

export default AccountTabPeople;